import axios from "axios";
import { defineStore } from "pinia";
import { useRouter } from "vue-router";

export const useEcommerceStore = defineStore('ecommerce', {
  state: () => ({
    cartItems: JSON.parse(localStorage.getItem('cartItems')) || [],
    email: '',
    password: '',
    currentUser: '',
    signin: false,
    user_id: null
  }),

  getters: {
    cartNumber(state) {
      return state.cartItems.reduce((sum, item) => sum + item.quantity, 0);
    },
    cartTotal(state) {
      return state.cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0).toFixed(2);
    }
  },

  actions: {
    _saveCart() {
      localStorage.setItem('cartItems', JSON.stringify(this.cartItems));
    },

    addToCartItem(item) {
      const existing = this.cartItems.find(i => i.name === item.name && i.image === item.image);
      if (existing) {
        existing.quantity += 1;
      } else {
        this.cartItems.push({ ...item, quantity: 1 });
      }
      this._saveCart();
    },

    updateQuantity(index, delta) {
      if (!this.cartItems[index]) return;
      this.cartItems[index].quantity += delta;
      if (this.cartItems[index].quantity <= 0) {
        this.cartItems.splice(index, 1);
      }
      this._saveCart();
    },

    removeFromCartItem(index) {
      this.cartItems.splice(index, 1);
      this._saveCart();
    },

    clearCart() {
      this.cartItems = [];
      this._saveCart();
    },

    async handleLogin(router) {
      try {
        const response = await axios.post('https://ecommerce-api.kalkidan.net/api/login', {
          email: this.email,
          password: this.password
        });
        const token = response.data.token;
        localStorage.setItem('token', token);
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        this.getUser();
        this.signin = true;
        localStorage.setItem('signin', this.signin);
        if (router) {
          router.push('/');
        }
      } catch (res) {
        console.log(res);
      }
    },

    async getUser() {
      try {
        const response = await axios.get('https://ecommerce-api.kalkidan.net/api/user');
        this.currentUser = response.data.user.user_name;
        localStorage.setItem('user_name', this.currentUser);
        this.user_id = response.data.user.id;
        localStorage.setItem('userID', this.user_id);
      } catch (err) {
        console.log('error', err);
      }
    },

    verifyLogin(router) {
      const token = localStorage.getItem('token');
      if (token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      } else {
        if (router) {
          router.push({ name: 'Signin' });
        }
      }
    },

    logOutUser(router) {
      localStorage.removeItem('token');
      localStorage.removeItem('signin');
      localStorage.removeItem('user_name');
      localStorage.removeItem('userID');
      if (router) {
        router.push({ name: 'Signin' });
      }
    }
  }
});
